module.exports = __webpack_public_path__ + "img/icon-lego-education.5cc14ef8.svg";